module.exports = __webpack_public_path__ + "static/media/icon_cerradura.ae8d1acd.svg";